import { create } from 'zustand'

const useUserStore = create((set) => ({
  activeUsers: [],
  fetchActiveUsers: async () => {
    try {
      const response = await fetch('/api/users/get-users?role=&isActive=');
      if (!response.ok) {
        throw new Error('Failed to fetch departments');
      }
      const data = await response.json();
      set({ activeUsers: data.result});
    } catch (error) {
      console.error('Error fetching activeUsers:', error);
      set({ activeUsers: [] });
    }
  },
}));

export default useUserStore